import UserPermissionStore from "@stores/UserPermissionStore";
import { useGlobalState } from "./useGlobalState";

const useUserPermissionStore = (): UserPermissionStore => {
  const [upStore] = useGlobalState("upStore");

  return upStore;
};

export default useUserPermissionStore;